import { Avatar } from "lib";
import { Mongo } from "meteor/mongo";

export const Avatars = new Mongo.Collection<Avatar>("avatars_u");
